import { AssetStatus } from "@hydrologiq/gql-experience/graphql"
import { AssignmentStatus } from "@hydrologiq/gql/graphql"

/**
 * Text on a status chip. The chips keep their bright fills in both Colour Modes, so the ink
 * stays dark in both too; the theme's `primary` turns near-white in dark mode and would vanish.
 */
export const STATUS_INK = "#2B2B2B"

/**
 * Returns the background hex colour for a given asset status.
 */
export function getAssetStatusColor(status: AssetStatus | null | undefined): string {
  switch (status) {
    case AssetStatus.Active:
    case AssetStatus.Deployed:
      return "#4ade80" // green
    case AssetStatus.Reserved:
      return "#b5e550"
    case AssetStatus.Servicing:
    case AssetStatus.Testing:
      return "#52d3d8"
    case AssetStatus.Filling:
    case AssetStatus.Standby:
      return "#f7d469"
    case AssetStatus.Outbound:
      return "#a4c8f0"
    case AssetStatus.Inbound:
    case AssetStatus.Startup:
      return "#52d3d8"
    case AssetStatus.DispatchReady:
      return "#74a8e2"
    case AssetStatus.DepotChecked:
      return "#50c878"
    case AssetStatus.Error:
      return "#ef4444" // red
    case AssetStatus.Unknown:
      return "#a1a1aa"
    default:
      return "#7fde9b" // available (default green)
  }
}

/**
 * Returns the text colour for a given asset status: dark ink in either Colour Mode, white on
 * Error's red.
 */
export function getAssetStatusTextColor(status: AssetStatus | null | undefined): string {
  return status === AssetStatus.Error ? "white" : STATUS_INK
}

/**
 * Returns the background hex colour for a given monitoring/assignment status.
 */
export function getMonitoringStatusColor(status: AssignmentStatus | null | undefined): string {
  switch (status) {
    case AssignmentStatus.Active:
      return "#4ade80" // green
    default:
      return "#d4d4d8" // gray
  }
}
